import { scroller, animateScroll as scroll } from 'react-scroll';
import { ConfigModel } from '@ibe/services';

class ScrollerService {
  static scrollToTop(): void {
    scroll.scrollToTop();
  }

  static scrollTo(
    value: string,
    props?: { [key: string]: string | number | undefined; scrollDuration?: number }
  ): void {
    scroller.scrollTo(value, {
      duration: props?.scrollDuration || 500,
      smooth: true,
      ...props
    });
  }

  static scrollToWithOffsetElement(
    value: string,
    offsetElementName: string,
    offsetFrom: 'top' | 'bottom',
    props?: { [key: string]: string | number | undefined; scrollDuration?: number }
  ): void {
    const element =
      document.getElementById(offsetElementName) ||
      document.getElementsByClassName(offsetElementName)[0];
    const elementOffset = element ? element.clientHeight : 0;
    scroller.scrollTo(value, {
      duration: props?.scrollDuration || 500,
      smooth: true,
      offset: offsetFrom === 'bottom' ? elementOffset : -elementOffset,
      ...props
    });
  }

  static scrollToY(
    el: HTMLElement | number,
    params: {
      isTablet?: boolean;
      isDesktop?: boolean;
      offset?: ConfigModel['headerScrollOffset'];
      scrollDuration?: number;
    }
  ): void {
    if (el !== undefined) {
      setTimeout(() => {
        const { offset, scrollDuration, isDesktop, isTablet } = params;
        let elementOffset = 0;
        if (offset) {
          elementOffset = offset.mobile;
          if (isDesktop) {
            elementOffset = offset.desktop;
          } else if (isTablet && offset.tablet) {
            elementOffset = offset.tablet;
          }
        }
        const top =
          typeof el === 'number'
            ? el
            : el.getBoundingClientRect().top + window.pageYOffset - elementOffset;
        scroll.scrollTo(top, { duration: scrollDuration || 500, smooth: true });
      }, 200);
    }
  }
}

export default ScrollerService;
